<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#3ea56e" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>

    <div v-else class="add-product-page">

      <!-- ── Page Header (same as customerEdit) ── -->
      <div class="page-header">
        <div class="page-title-group">
          <v-icon class="page-title-icon">mdi-account-circle</v-icon>
          <div>
            <h1 class="page-title">User Details</h1>
          </div>
        </div>
        <div v-if="user && user._id">
          <v-btn
            depressed dark
            color="#4CAF50"
            class="edit-btn text-capitalize"
            small
            @click="$router.push('/customerEdit?user=' + user._id)"
          >
            <v-icon left small>mdi-pencil-outline</v-icon>
            Edit User
          </v-btn>
        </div>
      </div>

      <!-- ── Form Body ── -->
      <div class="form-body" v-if="user">

        <!-- ── Hero Profile Card (from screenshot) ── -->
        <div class="hero-section mb-5">
          <div class="hero-bg">
            <div class="deco-circle deco-1"></div>
            <div class="deco-circle deco-2"></div>
          </div>
          <div class="hero-content">
            <div class="avatar-container">
              <v-avatar size="80" class="hero-avatar" v-if="user.image">
                <img :src="mediaUURL + user.image" />
              </v-avatar>
              <div class="hero-avatar hero-initials" v-else>
                {{ (user.firstname || '').charAt(0).toUpperCase() }}{{ (user.lastname || '').charAt(0).toUpperCase() }}
              </div>
              <!-- <div class="avatar-badge">
                <v-icon size="11" color="white">mdi-check</v-icon>
              </div> -->
            </div>
            <div class="hero-info">
              <h2 class="hero-name">{{ user.firstname }} {{ user.lastname }}</h2>
              <!-- <div class="active-chip" :class="user.status === 'Active' || user.status === 'active' ? 'chip-active' : 'chip-other'">
                <v-icon size="13" :color="user.status === 'Active' || user.status === 'active' ? '#3ea56e' : '#9e9e9e'">mdi-check-circle</v-icon>
                <span>{{ user.status || 'Unknown' }}</span>
              </div> -->
              <div class="hero-email-row">
                <v-icon size="14" color="#6b7280">mdi-email-outline</v-icon>
                <span>{{ user.email }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ── 01 Personal Information ── -->
        <div class="form-section">
          <div class="section-header">
            <span class="section-number">01</span>
            <div>
              <h2 class="section-title">Personal Information</h2>
            </div>
          </div>
          <div class="section-body">
            <v-row>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">First Name</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-account</v-icon>
                    <span class="read-value">{{ user.firstname || '—' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">Last Name</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-account-outline</v-icon>
                    <span class="read-value">{{ user.lastname || '—' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">Username</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-badge-account-horizontal</v-icon>
                    <span class="read-value">{{ user.username || '—' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">Gender</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-gender-male-female</v-icon>
                    <span class="read-value">{{ user.gender || '—' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">Role</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-shield-account</v-icon>
                    <span class="read-value">{{ user.type || '—' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">User Status</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-toggle-switch</v-icon>
                    <span class="status-pill" :class="user.status === 'Active' || user.status === 'active' ? 'pill-active' : 'pill-other'">{{ user.status || '—' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">Account Created On</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-calendar-clock</v-icon>
                    <span class="read-value">{{ user.account_create_at ? formatDate(user.account_create_at) : '—' }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- ── 02 Contact Information ── -->
        <div class="form-section">
          <div class="section-header">
            <span class="section-number">02</span>
            <div>
              <h2 class="section-title">Contact Information</h2>
            </div>
          </div>
          <div class="section-body">
            <v-row>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">Email</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-email</v-icon>
                    <span class="read-value">{{ user.email || '—' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-group">
                  <label class="field-label">Phone</label>
                  <div class="read-field">
                    <v-icon size="16" color="#9e9e9e" class="mr-2">mdi-phone</v-icon>
                    <span class="read-value">{{ user.phone || '—' }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- ── Action Row ── -->
        <v-row class="mt-4 pb-12">
          <v-col cols="12" sm="6">
            <v-btn block large depressed @click="$router.go(-1)" style="border-radius: 8px; border: 1px solid #dde3ea;" class="text-capitalize">
              <v-icon left>mdi-arrow-left</v-icon>
              Back
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6">
            <v-dialog v-model="dialog" max-width="420px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on" v-bind="attrs"
                  block large depressed dark
                  color="#e53935"
                  class="remove-btn text-capitalize"
                >
                  <v-icon left>mdi-delete-outline</v-icon>
                  Remove User
                </v-btn>
              </template>
              <v-card class="pa-2">
                <v-card-title class="font-weight-bold" style="font-size:16px;">Confirm Removal</v-card-title>
                <v-card-text class="grey--text text--darken-1">
                  Are you sure you want to remove this user? This action cannot be undone.
                </v-card-text>
                <v-card-actions class="pb-3 px-4">
                  <v-spacer></v-spacer>
                  <v-btn text class="text-capitalize" @click="dialog = false">Cancel</v-btn>
                  <v-btn depressed dark color="#e53935" class="text-capitalize" @click="deleteuser()">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import PurchaseDetails from "./purchaseDetails";
export default {
  //   components: { PurchaseDetails },
  data() {
    return {
      msg: null,
      ServerError: false,
      showsnackbar: false,
      user: [],
      appLoading: false,
      dialog: false,
      userStatus: null,
      userRole: localStorage.getItem("role"),
      tab: null,
      items: [" Profile Details"]   //, " Purchase Details"
      , product: [],
      photos: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    winStepper(winStep) {
      if (winStep.showsnackbar) {
        this.showsnackbar = true;
        this.msg = winStep.msg;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/info",
        params: {
          id: this.$route.query.user,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.user = response.data.data;
            // this.userStatus = this.user.status;
            // console.log(this.user);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    deleteuser() {
      axios({
        url: "/user/remove",
        method: "GET",
        params: {
          id: this.$route.query.user,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.dialog = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Deleted Sucessfully";
            this.showsnackbar = true;
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day + " " + dt.slice(4, 7) + " " + year + " " + hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>

<style scoped>
/* ── Shared with customerEdit ── */
.add-product-page {
  min-height: 100vh;
  background: #f6f8fb;
}

/* Page Header */
.page-header {
  background: #ffffff;
  border-bottom: 1px solid #e8ecf0;
  padding: 20px 28px;
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-title-group {
  display: flex;
  align-items: center;
  gap: 14px;
}
.page-title-icon {
  font-size: 28px !important;
  color: #4caf50;
}
.page-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 20px;
  color: #1c1c1c;
  margin: 0;
  line-height: 1.2;
}
.edit-btn {
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  box-shadow: 0 3px 10px rgba(76,175,80,0.25) !important;
}

/* Form Body */
.form-body {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 20px 48px;
}

/* ── Hero Section (from screenshot) ── */
.hero-section {
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  overflow: hidden;
  position: relative;
}
.hero-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #e8f5e9 0%, #f4fbf6 60%, #d6f0e0 100%);
  overflow: hidden;
}
.deco-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(62, 165, 110, 0.09);
}
.deco-1 { width: 200px; height: 200px; right: -30px; top: -60px; }
.deco-2 { width: 130px; height: 130px; right: 90px; top: 10px; }
.hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px 28px;
  flex-wrap: wrap;
}
.avatar-container { position: relative; flex-shrink: 0; }
.hero-avatar {
  border: 3px solid #fff !important;
  box-shadow: 0 4px 14px rgba(62,165,110,0.18) !important;
}
.hero-initials {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #c8e6c9;
  color: #2d8257;
  font-size: 26px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
  box-shadow: 0 4px 14px rgba(62,165,110,0.18);
}
.avatar-badge {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #3ea56e;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero-name {
  font-size: 20px;
  font-weight: 800;
  color: #1a1a2e;
  margin: 0 0 5px;
}
.active-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 7px;
}
.chip-active {
  background: rgba(255,255,255,0.85);
  color: #3ea56e;
  border: 1px solid #c8e6c9;
}
.chip-other {
  background: #f3f4f6;
  color: #6b7280;
}
.hero-email-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #4b5563;
}

/* ── Section Cards (same as customerEdit) ── */
.form-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  margin-bottom: 20px;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.form-section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}
.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border-bottom: 1px solid #f0f3f7;
  background: #fafbfc;
}
.section-number {
  font-family: poppinssemibold, sans-serif;
  font-size: 22px;
  color: #d0d8e4;
  line-height: 1;
  min-width: 36px;
}
.section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 15px;
  color: #1c1c1c;
  margin: 0;
}
.section-body { padding: 20px 24px; }

/* Field Groups */
.field-group { margin-bottom: 4px; }
.field-label {
  display: block;
  font-family: poppinssemibold, sans-serif;
  font-size: 12px;
  color: #555;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* Read-only field display (mimics outlined input look) */
.read-field {
  display: flex;
  align-items: center;
  min-height: 40px;
  border: 1px solid #dde3ea;
  border-radius: 8px;
  padding: 0 12px;
  background: #fdfdfd;
  transition: border-color 0.2s;
}
.read-field:hover {
  border-color: #4caf50;
}
.read-value {
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
}

/* Status pill */
.status-pill {
  display: inline-block;
  border-radius: 20px;
  padding: 2px 12px;
  font-size: 12px;
  font-weight: 600;
}
.pill-active {
  background: #e8f5e9;
  color: #2d8257;
}
.pill-other {
  background: #f3f4f6;
  color: #6b7280;
}

/* Action Buttons */
.remove-btn {
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  height: 48px !important;
  box-shadow: 0 4px 14px rgba(229, 57, 53, 0.3) !important;
}

/* Responsive */
@media (max-width: 960px) {
  .form-body { padding: 16px 12px 40px; }
  .section-header { padding: 14px 16px; }
  .section-body { padding: 14px 16px; }
  .page-header { padding: 14px 16px; }
  .hero-content { padding: 18px 16px; }
}
@media (max-width: 600px) {
  .section-number { font-size: 16px; min-width: 28px; }
  .section-title { font-size: 14px; }
}
</style>
